module.exports = __webpack_public_path__ + "img/45.3d22e199.png";